import React, { useState, useRef, Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { history } from "../../helpers/history";
import clientmanagmentObj from "../../services/client-managment.service";
import DateFormat from "../../helpers/DateFormat";
import crossImgs from "../../assets/images/icons/cross.svg";
import RefreshToken from "../../helpers/RefreshToken";
import ReactDatePickerHelper from "../../helpers/ReactDatePickerHelper";
import ExportToExcel from "./ExportToExcel";
import { haspermissions } from "../permissions/PermissionTypes";
import { useDispatch, useSelector } from "react-redux";
import CurrencyFormat from 'react-currency-format';
import ModelPopup from "../../helpers/ModelPopup";
import BoLoader from "../../helpers/BoLoader";
import TransferClient from "./TransferClient";

const SearchGridInputData = [
  {
    Name: "",
    ClientId: "",
    DateFrom: "",
    TokenId:"",
    DateTo: "",
    startIndex: 1,
    scrolled: false,
    isFirstTime: true,
    Status: "",
    TransactionType:"",
    Amount:"",
    FetchAll:false
  },
];
var fontStyle = {
  textTransform: "uppercase",
};
var isledgerhistory = "col-sm-2 toRight ms-auto mt-sm-100 mt-4 mb-4";

const SearchGridDebitTransaction = (props) => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [modalShow, setModalShow] = useState(false);
  const [name, setCompanyName] = useState("");
  const [clientId, setclientId] = useState("");
  const [tokenId, setTokenId] = useState("");
  const [TransactionType, setTransactionType] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const searchTbl = useRef();
  const [loadingData, setLoadingData] = useState(false);
  const [searchData, setSearchData] = useState();
  const [searchGridSuccess, setSearchGridSuccess] = useState(false);
  const [AllClientClassName, setAllClientClassName] = useState("nav-link");
  const [NewClientClassName, setNewClientClassName] = useState("nav-link");
  const [AllClientAreaSelected, setAllClientAreaSelected] = useState("false");
  const [NewClientsAreaSelected, setNewClientsAreaSelected] = useState("false");
  const [SearchInputDisabled, setSearchDisabled] = useState(false);
  const [clientIdVal, setClientIdVal] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [classContent, setClassContent] = useState("tab-content");
  const [Status, setStatus] = useState("");
  const [Amount, setAmount] = useState("");
  const [dataset, setDataset] = useState();
  const [balance, setBalance] = useState();
  const [walletId, setWalletId] = useState(null);
  const [isProfileLoaded, setIsProfileLoaded] = useState(false);
  const [apiBalanceKaped, setApiBalanceKaped] = useState();
  const [apiBalanceIssuerM, setApiBalanceIssuerM] = useState();
  const [apiBalanceIssuerWex, setApiBalanceIssuerWex] = useState();
  const [apiBalanceIssuerCap, setApiBalanceIssuerCap] = useState();
  const [apiBalanceIssuerI, setApiBalanceIssuerI] = useState();
  const [apiBalanceIssuerESL, setApiBalanceIssuerESL] = useState();
  const [apiBalanceIssuerOB, setApiBalanceIssuerOB] = useState();
  const [apiBalanceIssuerSkrill, setApiBalanceIssuerSkrill] = useState();
  const [apiBalanceIssuerTGVN, setApiBalanceIssuerTGVN] = useState();
  const [apiBalanceIssuerER, setApiBalanceIssuerER] = useState();
  const [isKapedClient, setisKapedClient] = useState(false);
  const [isIssuerBalanceM, setIsIssuerBalanceM] = useState(false);
  const [isIssuerBalanceX, setIsIssuerBalanceX] = useState(false);
  const [isIssuerBalanceESL, setIsIssuerBalanceESL] = useState(false);
  const [isIssuerBalanceER, setIsIssuerBalanceER] = useState(false);
  const [isIssuerBalanceOB, setIsIssuerBalanceOB] = useState(false);
  const [isIssuerBalanceWex, setIsIssuerBalanceWex] = useState(false);
  const [isIssuerBalanceCap, setIsIssuerBalanceCap] = useState(false);
  const [isIssuerBalanceSkrill, setIsIssuerBalanceSkrill] = useState(false);
  const [isIssuerBalanceTGVN, setIsIssuerBalanceTGVN] = useState(false);
  const [Frozenloadbalance, setFrozenloadbalance] = useState();
  const [Frozendebitbalance, setFrozendebitbalance] = useState();
  const [isFrozenBalances, setIsFrozenBalances] = useState(false);
  const [isIssuerIClient, setIsIssuerIClient] = useState(false);
  const [isExcelDownload, setiisExcelDownload] = useState(false);
  const [showExcelDownloadModal, setshowExcelDownloadModal] = useState(false);
  const [boloader, setBoLoader] = useState(false);
  const [currency, setcurrency] = useState("");
  const [IssuerCategory, setIssuerCategory] = useState("");
  const [masterClientId, setmasterClientId] = useState();
  const [clientprofile, setClientprofile] = useState();
  const [isOldData, setIsOldData] = useState(false);
  const [wexTabActive, setWexTabActive] = useState(true);
  const [modalShowTransferClient, setModalShowTransferClient] = useState(false);
    const [modalShowTransactions, setModalShowTransactions] = useState(false);
    const [TransactionsType, setTransactionsType] = useState("");
      const [ApprovalCode, setApprovalCode] = useState("");
  const [CurrencyCode, setCurrencyCode] = useState("");
 const [date, setDate] = useState("");
  const [ReferenceNumber, setReferenceNumber] = useState("");
  const [MerchantName, setMerchantName] = useState("");
  const [DescriptionGlobal, setDescriptionGlobal] = useState("");

  if (currentUser) {
    haspermissions.ViewLedgerBalance = currentUser?.user?.Permissions?.includes("View ledger balance");
    if (!haspermissions.ViewLedgerBalance)
      isledgerhistory = "col-sm-5 toRight ms-auto"
    haspermissions.ViewLedgerHistory = currentUser?.user?.Permissions?.includes("View ledger history");

  }
  
  useEffect(() => {
    if (props?.calledfrom === "dashboard")
      setClassContent("");
    clientmanagmentObj
      .getprofiledetails(props?.clientId).then((response) => {
        let res = response.data.payload.result;
        setBalance(res?.balance);
        setWalletId(res?.walletId);
        setClientprofile(res);
        setcurrency(res?.currencyCode);
        setIssuerCategory(res?.issuerCategory);
       
        if(res?.issuerCategory==="IssuerM"){
          getApiLegderBalanceForKAped();
          getApiLegderBalanceForIssuerM();
          setIsIssuerBalanceM(true);
        }
        if(res?.issuerCategory==="IssuerX"){
          getApiLegderBalanceForIssuerX();
          setIsIssuerBalanceX(true);
        }
        if(res?.issuerCategory==="IssuerE"){
          getApiLegderBalanceForIssuerESL();
          setIsIssuerBalanceESL(true);
        }
         if(res?.issuerCategory==="IssuerOB"||res?.issuerCategory==="Issuer11"||res?.issuerCategory==="Issuer12" ||
          res?.issuerCategory==="OB-TIX" ||res?.issuerCategory==="OB-FIT" || res?.issuerCategory==="OB-OF"
         ){
          getApiLegderBalanceForIssuerOB();
          setIsIssuerBalanceOB(true);
        }
        if(res?.issuerCategory==="IssuerWex"){
          getApiLegderBalanceForIssuerWex();
          setIsIssuerBalanceWex(true);
        }
        if(res?.issuerCategory==="IssuerCap-SG"|| res?.issuerCategory==="IssuerCap-NKT"){
          getApiLegderBalanceForIssuerCap();
          setIsIssuerBalanceCap(true);
        }
        
         if(props?.clientId== 278 || res?.issuerCategory==="IssuerSkrill"){
          setmasterClientId(props?.clientId);
          setIsIssuerBalanceSkrill(true);
          getApiLegderBalanceForIssuerSkrill();
        }
        if(props?.clientId== 303){
           setmasterClientId(props?.clientId);
        }
         if(res?.issuerCategory==="IssuerTGVN"){
          getApiLegderBalanceForIssuerTGVN();
          setIsIssuerBalanceTGVN(true);
        }
        if(res?.issuerCategory==="IssuerER"){
          getApiLegderBalanceForIssuerER();
          setIsIssuerBalanceER(true);
        }
        if(res?.issuerCategory==="IssuerM"||res?.issuerCategory==="IssuerG"){
          getApiFrozenBalances();
          setIsFrozenBalances(true);
        }
        // Set profile loaded flag and call allClients after all data is set
        setIsProfileLoaded(true);
        // Only call allClients (which triggers transaction API) if walletId is null
          allClients(props?.clientId);
      }).catch();
  }, []);

 const getApiLegderBalanceForKAped=()=>{
  clientmanagmentObj
  .getIssuebMainBalance(props?.clientId).then((response) => {
    let res = response?.data?.payload?.result;
    setApiBalanceKaped(res);
    setApiBalanceIssuerI(res);

  }).catch();
 }
  const getApiFrozenBalances=()=>{
  clientmanagmentObj
  .getApiFrozenBalances(Number(props?.clientId)).then((response) => {
    let res = response?.data?.payload;
    setFrozenloadbalance(res?.loadBalance );
    setFrozendebitbalance(res?.debitBalance );

  }).catch();
 }
 const getApiLegderBalanceForIssuerM=()=>{
  clientmanagmentObj
  .getIssuebMainBalance(10000).then((response) => {
    let res = response?.data?.payload?.result;
    setApiBalanceIssuerM(res);
  }).catch();
 }
  const getApiLegderBalanceForIssuerX=()=>{
  clientmanagmentObj
  .getIssuebMainBalance(11000).then((response) => {
    let res = response?.data?.payload?.result;
    setApiBalanceIssuerM(res);
  }).catch();
 }
   const getApiLegderBalanceForIssuerESL=()=>{
  clientmanagmentObj
  .getIssuebMainBalance(props?.clientId).then((response) => {
    let res = response?.data?.payload?.result;
    setApiBalanceIssuerESL(res);
  }).catch();
 }
   const getApiLegderBalanceForIssuerER=()=>{
  clientmanagmentObj
  .getIssuebMainBalance(props?.clientId).then((response) => {
    let res = response?.data?.payload?.result;
    setApiBalanceIssuerER(res);
  }).catch();
  
 }
  const getApiLegderBalanceForIssuerOB=()=>{
  clientmanagmentObj
  .getIssuebMainBalance(props?.clientId).then((response) => {
    let res = response?.data?.payload?.result;
    setApiBalanceIssuerOB(res);
  }).catch();
 }
  const getApiLegderBalanceForIssuerWex=()=>{
  clientmanagmentObj
  .getIssuebMainBalance(props?.clientId).then((response) => {
    let res = response?.data?.payload?.result;
    setApiBalanceIssuerWex(res);
  }).catch();
 }
   const getApiLegderBalanceForIssuerCap=()=>{
  clientmanagmentObj
  .getIssuebMainBalance(props?.clientId).then((response) => {
    let res = response?.data?.payload?.result;
    setApiBalanceIssuerCap(res);
  }).catch();
 }
   const getApiLegderBalanceForIssuerSkrill=()=>{
  clientmanagmentObj
  .getIssuebMainBalance(props?.clientId).then((response) => {
    let res = response?.data?.payload?.result;
    setApiBalanceIssuerSkrill(res);
  }).catch();
 }
   const getApiLegderBalanceForIssuerTGVN=()=>{
  clientmanagmentObj
  .getIssuebMainBalance(props?.clientId).then((response) => {
    let res = response?.data?.payload?.result;
    setApiBalanceIssuerTGVN(res);
  }).catch();
  
 }
 
  const handleInputSearchClick = (e) => {
    e.preventDefault();
    setModalShow(true);
    setSearchDisabled(true);
    setclientId("");
    setTokenId("");
    setCompanyName("");
    dateToHandler("");
    dateFromHandler("");
  };
  const nameChangeHandler = (e) => {
    SearchGridInputData[0].Name = e.target.value;
    setCompanyName(SearchGridInputData[0].Name);
  };
  const tokenChangeHandler = (e) => {
    SearchGridInputData[0].TokenId = e.target.value;
    
    
      setTokenId(e.target.value);
  };
  const transactionTypeChangeHandler = (e) => {
    SearchGridInputData[0].TransactionType = e.target.value;
    setTransactionType(e.target.value);
    
  };
  const StatusChangeHandler = (e) => {
    SearchGridInputData[0].Status = e.target.value;
    setStatus(e?.target?.value);
    
  };
 const AmountChangeHandler = (e) => {
    SearchGridInputData[0].Amount = e.target.value;
    setAmount(e?.target?.value);
    
  };
  const dateFromHandler = (e) => {
    SearchGridInputData[0].DateFrom = e;
    if (e)
      SearchGridInputData[0].DateFrom = dateFilter(
        SearchGridInputData[0].DateFrom
      );
    setDateFrom(SearchGridInputData[0].DateFrom);
  };
  const dateFilter = (date) => {
    return new Date(date);
  };
  const dateToHandler = (e) => {
    SearchGridInputData[0].DateTo = e;
    if (e)
      SearchGridInputData[0].DateTo = dateFilter(SearchGridInputData[0].DateTo);
    setDateTo(SearchGridInputData[0].DateTo);
  };
  const SearchClickHandler = (e, isFromUseEffect) => {

    if (e) {
      e.preventDefault();
      SearchGridInputData[0].startIndex = 1;
    }
    if (clientId || clientIdVal !== "")
      SearchGridInputData[0].ClientId = !clientId
        ? clientIdVal
        : clientId;
    else SearchGridInputData[0].ClientId = "";
    setLoadingData(true);
    HideSearchPopupDiv();
    if (!SearchGridInputData[0].scrolled) {
      setSearchGridSuccess(false);
    }
    if(masterClientId === 278 || isFromUseEffect===278){
      clientmanagmentObj
      .gettransactionskrill(
        100, // limit - default value
        SearchGridInputData[0].startIndex - 1, // offset (startIndex - 1 since API uses 0-based offset)
        dateFrom || "",
        dateTo || "",
        tokenId || 0
      )
      .then((resp) => {
        setLoadingData(false);
        if (resp && resp.data && resp.data.payload) {
          if (resp.data.success) {
            setModalShow(false);
            setSearchDisabled(false);
          }
          if (
            resp.data.payload.transactions.length > 0 ||
            searchData.length > 0
          ) {
            // Filter out transactions older than April 2nd, 2026
            const cutoffDate = new Date('2026-04-02T00:00:00');
            const filteredTransactions = resp.data.payload.transactions.filter(transaction => {
              const transactionDate = new Date(transaction.createDate);
              return transactionDate >= cutoffDate;
            });

            setTotalCount(filteredTransactions.length);
            if (SearchGridInputData[0].scrolled) {
              let appendedData = searchData.concat(
                filteredTransactions
              );
              setSearchData(appendedData);
              setDataset(appendedData);
            } else {
              setSearchData(filteredTransactions);
              setDataset(filteredTransactions);
              SearchGridInputData[0].startIndex = 1;
            }
            setSearchGridSuccess(true);

            SearchGridInputData[0].scrolled = false;
            searchTbl.current.onscroll = tblScrollHandler;
            SearchGridInputData[0].isFirstTime = false;
          }
        }
      })
      .catch((error) => {
        setSearchGridSuccess(false);
        setLoadingData(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            SearchClickHandler();
          }
        })();
      });
    }  else if((masterClientId === 303 || isFromUseEffect===303) && wexTabActive){
      clientmanagmentObj
      .getwextransaction(
        100, // limit - default value
        SearchGridInputData[0].startIndex - 1, // offset (startIndex - 1 since API uses 0-based offset)
        dateFrom || "",
        dateTo || "",
        tokenId || 0
      )
      .then((resp) => {
        setLoadingData(false);
        if (resp && resp.data && resp.data.payload) {
          if (resp.data.success) {
            setModalShow(false);
            setSearchDisabled(false);
          }
          if (
            resp.data.payload.content.length > 0 ||
            searchData.length > 0
          ) {
            const filteredTransactions = resp?.data?.payload?.content;

            setTotalCount(filteredTransactions.length);
            if (SearchGridInputData[0].scrolled) {
              let appendedData = searchData.concat(
                filteredTransactions
              );
              setSearchData(appendedData);
              setDataset(appendedData);
            } else {
              setSearchData(filteredTransactions);
              setDataset(filteredTransactions);
              SearchGridInputData[0].startIndex = 1;
            }
            setSearchGridSuccess(true);

            SearchGridInputData[0].scrolled = false;
            searchTbl.current.onscroll = tblScrollHandler;
            SearchGridInputData[0].isFirstTime = false;
          }
        }
      })
      .catch((error) => {
        setSearchGridSuccess(false);
        setLoadingData(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            SearchClickHandler();
          }
        })();
      });
    } else if(isOldData){
      clientmanagmentObj
      .gettransactionhistory(
        name,
        tokenId,
        props?.clientId.toString(),
        dateFrom || new Date("0001-01-01"),
        dateTo || new Date("0001-01-01"),
        SearchGridInputData[0].startIndex,
        Status,
        props?.userId,
        TransactionType,
        SearchGridInputData[0].FetchAll
      )
      .then((resp) => {
        setLoadingData(false);
        if (resp && resp.data && resp.data.payload) {
          if (resp.data.success) {
            setModalShow(false);
            setSearchDisabled(false);
          }
          if (
            resp.data.payload.result.pageModel.length > 0 ||
            searchData.length > 0
          ) {
            setTotalCount(resp.data.payload.result.totalCount);
            if (SearchGridInputData[0].scrolled) {
              let appendedData = searchData.concat(
                resp.data.payload.result.pageModel
              );
              setSearchData(appendedData);
              setDataset(appendedData);
            } else {
              setSearchData(resp.data.payload.result.pageModel);
              setDataset(resp.data.payload.result.pageModel);
              SearchGridInputData[0].startIndex = 1;
            }
            setSearchGridSuccess(true);

            SearchGridInputData[0].scrolled = false;
            searchTbl.current.onscroll = tblScrollHandler;
            SearchGridInputData[0].isFirstTime = false;
            // }
          }
        }
      })
      .catch((error) => {
        setSearchGridSuccess(false);
        setLoadingData(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            SearchClickHandler();
          }
        })();
      });
    } else{
      clientmanagmentObj
      .searhGridDebit(
        name,
        tokenId,
        props?.clientId.toString(),
        dateFrom || new Date("0001-01-01"),
        dateTo || new Date("0001-01-01"),
        SearchGridInputData[0].startIndex,
        Status,
        props?.userId,
        TransactionType,
        SearchGridInputData[0].FetchAll,
        "",
        Amount
      )
      .then((resp) => {
        setLoadingData(false);
        if (resp && resp.data && resp.data.payload) {
          if (resp.data.success) {
            setModalShow(false);
            setSearchDisabled(false);
          }
          if (
            resp.data.payload.result.pageModel.length > 0 ||
            searchData.length > 0
          ) {
            setTotalCount(resp.data.payload.result.totalCount);
            if (SearchGridInputData[0].scrolled) {
              let appendedData = searchData.concat(
                resp.data.payload.result.pageModel
              );
              setSearchData(appendedData);
              setDataset(appendedData);
            } else {
              setSearchData(resp.data.payload.result.pageModel);
              setDataset(resp.data.payload.result.pageModel);
              SearchGridInputData[0].startIndex = 1;
            }
            setSearchGridSuccess(true);

            SearchGridInputData[0].scrolled = false;
            searchTbl.current.onscroll = tblScrollHandler;
            SearchGridInputData[0].isFirstTime = false;
            // }
          }
        }
      })
      .catch((error) => {
        setSearchGridSuccess(false);
        setLoadingData(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            SearchClickHandler();
          }
        })();
      });
    }
   
  };

  const tblScrollHandler = (e) => {
    if (
      !SearchGridInputData[0].scrolled &&
      SearchGridInputData[0].startIndex + 30 <= totalCount
    ) {
      SearchGridInputData[0].scrolled = true;
      SearchGridInputData[0].startIndex =
        SearchGridInputData[0].startIndex + 30;
      SearchClickHandler();
    }
  };

  const renderTableHeader = () => {
   
    let header = Object.values(props.headersdata);
    if(masterClientId==278){
      header=Object.values([
            "AMOUNT",
            "CREATED DATE",
            "CURRENCY",
            "EXECUTED DATE",
            "STATE",
            "TYPE"
          ]);
    }
     if(masterClientId==303 && wexTabActive){
      header=Object.values([
            "TRANSACTION TYPE",
            "MERCHANT NAME",
            "AMOUNT",
            "STATUS",
            "DATE",
            "VIEW"
          ]);
    }
    if(IssuerCategory=="IssuerSkrill" && masterClientId!=278){
      header=Object.values([
            "DATE",
            "TRANSACTION",
            "STATUS",
            "TYPE",
            "TNX ID",
            "AMOUNT",
            "DESCRIPTION",
          ]);
    }
    return header.map((key, index) => {
      if(IssuerCategory!="IssuerSkrill" && IssuerCategory!="IssuerG" && !(masterClientId=="303" && wexTabActive) && key=="STATUS" )
        return
      else
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  };
  const didMountTabRef = useRef(false);
  const switchTransactionsTab = (toWex) => {
    if (toWex === wexTabActive) return;
    setWexTabActive(toWex);
    SearchGridInputData[0].startIndex = 1;
    SearchGridInputData[0].scrolled = false;
    setSearchData([]);
    setDataset([]);
    setTotalCount(0);
    setSearchGridSuccess(false);
  };
  useEffect(() => {
    if (!didMountTabRef.current) {
      didMountTabRef.current = true;
      return;
    }
    if (isProfileLoaded && masterClientId == 303) {
      SearchClickHandler("", 303);
    }
  }, [wexTabActive]);
  const allClients = (issuerCategory) => {
    setAllClientClassName("nav-link active d-flex align-items-center");
    setAllClientAreaSelected("true");
    setNewClientClassName("nav-link d-flex align-items-center");
    setNewClientsAreaSelected("false");
    setSearchDisabled(false);
    SearchGridInputData[0].startIndex = 1;
    SearchGridInputData[0].ClientId = "";
    setCompanyName("");
    dateToHandler("");
    dateFromHandler("");
    setclientId("");
    setClientIdVal("");
    SearchClickHandler("",issuerCategory);
  };

  const showCardHolderDetailPage = (id,userId,cardStatus,issuerCategory) => {
    if(id &&issuerCategory&&userId)
    history.push("/cardholderdetails", {id,userId,cardStatus,issuerCategory});
  };
    const sanitizeDate = (dateStr) => {
    return dateStr?.startsWith("0001-01-01") ? true : false;
  };

    const showTransactionsPopup = (
    transactionType,
    merchantName,
    status,
    cardTransactionAmount,
    transactionCurrencyCode,
    dateOfTransaction,
    retrievalReferenceNumber,
    transactionResponse,
    description,approvalCode,localDescription,transactionMode
  ) => {
    setModalShowTransactions(true);
    setTransactionsType(transactionType);
    setApprovalCode(approvalCode);
    setStatus(status);
    setCurrencyCode(transactionCurrencyCode);
    setAmount(cardTransactionAmount);
    setDate(dateOfTransaction);
    setReferenceNumber(retrievalReferenceNumber);
    setMerchantName(merchantName);
    setDescriptionGlobal(description);

  };
  const renderTableData = () => {
    return searchData.map((data, index) => {
      const {
        clientName,
        toClient,
        tokenId,
        amount,
        createdDate,
        debitCredit,
        currencyCode,
        description,
        transactionType,
        uniqueUserId,
        cardHolderUuid,
        issuerCategory,currency,executeDate,planDate,state,transactionId,type,createDate,
        merchantName,
        status,
        authCurrencyCode,
        authAmount,
        dateOfTransaction,
        retrievalReferenceNumber,
        transactionCountry,
        transactionResponse,localDescription,approvalCode,sourceAmount,transactionMode
      } = data; //destructuring
      return (
        <>
        {masterClientId==278 ?(<>
        <tr key={transactionId}>
                    <td style={fontStyle} title={amount}>{amount}</td>
                     <td >
            <DateFormat date={createDate} />
          </td>
          <td style={fontStyle} title={currency}>{currency}</td>
           <td >
            <DateFormat date={executeDate} />
          </td>
          <td style={fontStyle} title={state}>{state}</td>
          <td style={fontStyle} title={type}>{type}</td>
        </tr>
      
        </>): (masterClientId==303 && wexTabActive)?(

          <tr key={retrievalReferenceNumber}>
          <td style={fontStyle} title={transactionType} >{transactionType?.substr(0, 20)}{transactionType?.length > 20 && ("...")}</td>
          <td style={fontStyle} title={merchantName} >{merchantName?.substr(0, 10) ?? '-'}{merchantName?.length > 10 && ("...")}</td>
       
          {
            transactionType=="authorization_reversal" && (approvalCode=="REV_ADVICE" || approvalCode=="REV_AUTO") ?(<>
             {
      <td><CurrencyFormat value={authAmount} displayType={'text'} thousandSeparator={true} allowNegative={false} prefix="(" suffix=")" /></td>
            
            }
            </>):(
              <>
               {
            authAmount < 0 ? (<td><CurrencyFormat value={authAmount} displayType={'text'} thousandSeparator={true} allowNegative={false} prefix="(" suffix=")" /></td>) : (
              <td style={fontStyle}><CurrencyFormat value={authAmount} displayType={'text'} thousandSeparator={true} /> </td>
            )
            }
              </>
            )
          }
          <td style={fontStyle}>{status}</td>

          {
            sanitizeDate(dateOfTransaction) ? (
              <td style={fontStyle}>

              </td>
            ) : (
              <td style={fontStyle}>
                <DateFormat date={dateOfTransaction} />
              </td>
            )
          }
          <td>
            <span
              className="icon-show"
              onClick={() =>
                showTransactionsPopup(
                  transactionType,
                  merchantName,
                  status,
                  authAmount,
                  authCurrencyCode,
                  dateOfTransaction,
                  retrievalReferenceNumber,
                  transactionResponse,
                  description,
                  approvalCode,localDescription,transactionMode

                )
              }
            ></span>
          </td>
        </tr>
        ):(<>
        
        <tr key={tokenId}>
          <td >
            <DateFormat date={createdDate} />
          </td>
          <td style={fontStyle} title={debitCredit}>{debitCredit}</td>
          <td style={fontStyle} title={transactionType}>{transactionType}</td>
          {issuerCategory=="IssuerG" &&(
            <td style={fontStyle} title={status}>{status}</td>
          )}
           {
            isIssuerBalanceSkrill && masterClientId!=278 &&(<td style={fontStyle} title={uniqueUserId}>{uniqueUserId?.substr(0, 10)}{uniqueUserId?.length > 10 && ("...")}</td>)
          }
          {
            (tokenId!=="0" &&transactionType!=="Deposit") ?(<td>  <span style={{ color:'#0d6efd',cursor:'pointer'}}  
             title="View Card Holder Details" onClick={() => showCardHolderDetailPage(cardHolderUuid,uniqueUserId,status,issuerCategory)} >
              {tokenId}</span></td>):(<td></td>)
          }
         
          <td style={fontStyle}><CurrencyFormat value={amount} displayType={'text'} thousandSeparator={true} /> {currencyCode}</td>
{
  issuerCategory !="IssuerSkrill" && (<>
   {
            transactionType==="Deposit" ?(
              <td style={fontStyle} title={ toClient} >
              {toClient?.substr(0, 20)}
              {toClient?.length > 10 && ("...")}</td> 
            ):(
            <Fragment>
              {transactionType==="SuspendCard"?(<Fragment>
                <td style={fontStyle} title={toClient} >
                      {toClient?.substr(0, 20)}
                      {toClient?.length > 10 && ("...")}</td>
              </Fragment>):
              
              (<Fragment>
                {transactionType==="DebitCard"  ?
              (<td>{toClient} </td>):

              (
              
              <td style={fontStyle} title={(debitCredit==="Credit" && transactionType==="LedgertoLedger") ? toClient:clientName} >
            {
            (debitCredit==="Credit" && transactionType==="LedgertoLedger")?toClient?.substr(0, 20):clientName?.substr(0, 20)}
            {clientName?.length > 10 && ("...")}
            </td>
            
            )}
              </Fragment>)}
             
            
            </Fragment>
            )
          }
          
          {
            transactionType==="Deposit" ?(
              <td style={fontStyle} title={ clientName} >
              {clientName?.substr(0, 20)}
              {clientName?.length > 10 && ("...")}</td> 
            ):(
              <Fragment>
              {transactionType==="LoadCard"  ?(<td>{toClient} </td>):
              
              (
                <Fragment>
                  {(debitCredit==="Credit" && transactionType==="DebitCard")?(
                     <td style={fontStyle} title={clientName} >
                     {clientName?.substr(0, 20)}
                     {clientName?.length > 10 && ("...")}</td>
                  ):(<Fragment>
                    {
                      transactionType==="SuspendCard"?(
                      <td style={fontStyle} title={clientName} >
                      {clientName?.substr(0, 20)}
                      {clientName?.length > 10 && ("...")}</td>):(
                      
                      <td style={fontStyle} title={(debitCredit==="Credit" && transactionType==="LedgertoLedger") ? clientName:toClient} >
                      {(debitCredit==="Credit" && transactionType==="LedgertoLedger")?clientName?.substr(0, 20):toClient?.substr(0, 20)}
                      {toClient?.length > 10 && ("...")}</td>)
                    }
                  </Fragment>
                    
                  )}

                
                 </Fragment>
              )}
             
            </Fragment>
            )
          }
  </>)
}
         
          
          <td style={fontStyle} title={description}>{description?.substr(0, 10)}{description?.length > 10 && ("...")}</td>
        </tr>
        </>)}
         
        </>
       
      );
    });
  };
  const HideSearchPopupDiv = () => {
    setModalShow(false);
    setSearchDisabled(false);
    setclientId("");
    setCompanyName("");
  };
  const ClearSearchData = () => {
    setclientId("");
    setCompanyName("");
    setTokenId("");
    dateToHandler("");
    dateFromHandler("");
    setStatus("");
    setAmount();
    setTransactionType("");
    setIsOldData(false);
    ClearInputData();
  };
  const ClearInputData = () => {
    if (document.getElementById("clientNameDD") !== null)
      document.getElementById("clientNameDD").value = "";
    setClientIdVal("");
    setTimeout(() => {
      [...document.getElementsByClassName("r-input-group")].forEach(
        (element) => {
          element.children[0].value = "";
        }
      );
      document.getElementById("searchBtnClients").click();
    }, 500);
  };

  const showExcelModel=(e)=>{
    setIsOldData(false);
    setshowExcelDownloadModal(true);
  }
   const downloadExportToExcel=()=>{
    setBoLoader(true);
    if(masterClientId === 278){
      clientmanagmentObj
      .gettransactionskrill(
        100, // limit - we can increase this for export
        0, // offset - start from beginning
        dateFrom || new Date("0001-01-01"),
        dateTo || new Date("0001-01-01"),
        tokenId || 0
      )
      .then((resp) => {
        setBoLoader(false);
        if (resp && resp.data && resp.data.payload) {
          setDataset(resp?.data?.payload?.result?.pageModel);
          setshowExcelDownloadModal(false);
          setiisExcelDownload(true);
          setDateFrom("");
          setDateTo("");
        }
      })
      .catch((error) => {
        setBoLoader(false);
        setSearchGridSuccess(false);
        setshowExcelDownloadModal(false);
        setLoadingData(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            downloadExportToExcel();
          }
        })();
      });
    }else if(masterClientId === 303 && wexTabActive){
      clientmanagmentObj
      .getwextransaction(
        100, // limit - we can increase this for export
        0, // offset - start from beginning
        dateFrom || new Date("0001-01-01"),
        dateTo || new Date("0001-01-01"),
        tokenId || 0
      )
      .then((resp) => {
        setBoLoader(false);
        if (resp && resp.data && resp.data.payload) {
          setDataset(resp?.data?.payload?.result);
          setshowExcelDownloadModal(false);
          setiisExcelDownload(true);
          setDateFrom("");
          setDateTo("");
        }
      })
      .catch((error) => {
        setBoLoader(false);
        setSearchGridSuccess(false);
        setshowExcelDownloadModal(false);
        setLoadingData(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            downloadExportToExcel();
          }
        })();
      });
    } else if(isOldData){
      clientmanagmentObj
      .gettransactionhistory(
        name,
        tokenId,
        props?.clientId.toString(),
        dateFrom || new Date("0001-01-01"),
        dateTo || new Date("0001-01-01"),
        SearchGridInputData[0].startIndex,
        Status,
        props?.userId,
        TransactionType,
        true,
        Amount
      )
      .then((resp) => {
        setLoadingData(false);
        if (resp && resp.data && resp.data.payload) {
          if (resp.data.success) {
            setBoLoader(false);
            setDataset(resp?.data?.payload?.result?.pageModel)
            setshowExcelDownloadModal(false);
            setiisExcelDownload(true);
            setDateFrom("");
            setDateTo("");
          
           
          }
            setTotalCount(resp.data.payload.result.totalCount);
            if (SearchGridInputData[0].scrolled) {
              let appendedData = searchData.concat(
                resp.data.payload.result.pageModel
              );
              setSearchData(appendedData);
              setDataset(appendedData);
            } else {
              setSearchData(resp.data.payload.result.pageModel);
              setDataset(resp.data.payload.result.pageModel);
              SearchGridInputData[0].startIndex = 1;
            }
            setSearchGridSuccess(true);

            SearchGridInputData[0].scrolled = false;
            searchTbl.current.onscroll = tblScrollHandler;
            SearchGridInputData[0].isFirstTime = false;
        }
      })
      .catch((error) => {
        setBoLoader(false);
        setSearchGridSuccess(false);
        setshowExcelDownloadModal(false);
        setLoadingData(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            SearchClickHandler();
          }
        })();
      });
    } else{ clientmanagmentObj
      .searhGridDebit(
        name,
        tokenId,
        props?.clientId.toString(),
        dateFrom || new Date("0001-01-01"),
        dateTo || new Date("0001-01-01"),
        SearchGridInputData[0].startIndex,
        Status,
        props?.userId,
        TransactionType,
        true,
        "",
        Amount
      ).then((resp)=>{
        setBoLoader(false);
        setDataset(resp?.data?.payload?.result?.pageModel)
        setshowExcelDownloadModal(false);
        setiisExcelDownload(true);
        setDateFrom("");
        setDateTo("");
      }).catch((error) => {
        setBoLoader(false);
        setSearchGridSuccess(false);
        setshowExcelDownloadModal(false);
        setLoadingData(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            downloadExportToExcel();
          }
        })();
      });}
   
    
   
  }
  const handleSingleCheck = e => {
    const chckSame = e.target.checked;
    if (chckSame === true) {
      setIsOldData(true);
    }
    if (chckSame === false) {
      setIsOldData(false);
    }
  
  };
    const renderTransactionDetails = () => {
    return (

      <div class="row">
        <div class="col-md-12">
          <h3>Transaction Details</h3>
          <div class="mt-16">
            <form onSubmit={(e) => e.preventDefault()}>
              <ul class="ul-card-details-popup">
                <li class="d-flex justify-content-between mb-3">
                  <label>Transaction Type</label>
                  <span>{TransactionsType}</span>
                </li>
                <li class="d-flex justify-content-between mb-3">
                  <label>Status</label>
                  <span>{Status}</span>
                </li>
                <li class="d-flex justify-content-between mb-3">
                  <label>Merchant Name</label>
                  <span>{MerchantName}</span>
                </li>
 
             
                      <Fragment>
                        <li class="d-flex justify-content-between mb-3">

                          {
                            Status === "COMPLETION" ? (<label> Settlement Amount</label>) : (<label>Amount</label>)
                          }
                          <span><CurrencyFormat value={Amount} displayType={'text'} thousandSeparator={true} /> &nbsp; {CurrencyCode} </span>
                        </li>
                      </Fragment>
                   
                <li class="d-flex justify-content-between mb-3">
                  <label>Date</label>
                  <span><DateFormat date={date} /></span>
                </li>

                <li class="d-flex justify-content-between">
                  <label>Ref #</label>
                  <span>{ReferenceNumber}</span>
                </li>

              </ul>

            </form>
          </div>
        </div>
      </div>

    );
  };
    const refereshTransac=()=>{
    
  }
  const resetModal=()=>{
    setIsOldData(false);
    setiisExcelDownload(false);
    dateToHandler("");
    dateFromHandler("");
  }
  return (
    <div className="">
      <BoLoader loading={boloader} />
      {!isProfileLoaded ? (
        <div className="loading-more">
          <div className="loader">
            <div></div>
          </div>
          <p>Loading...</p>
        </div>
      ) : (
      <>
      <div id="myTabContent2">
        <div
          className="tab-pane fade show active"
          id="allClients"
          role="tabpanel"
          aria-labelledby="allClients-tab"
        >
          <div className="row" >

            {haspermissions.ViewLedgerBalance && (
              <Fragment>
              <div className="col-sm-7 col-xl-3">
                <div
                  className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
                  style={{ backgroundImage: `url(${""})`}}
                >
                  <h3 className="mt-20">&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;{clientprofile?.clientName}</h3> 
                  <br/>
                  {
                    masterClientId==278 ?(<>
                     <h3 className="text-center">&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;Ledger Balance:
                     <CurrencyFormat value={apiBalanceIssuerSkrill} displayType={'text'} thousandSeparator={true} /> {"EUR"}&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
                  </h3></>):(<>
                     <h3 className="text-center">&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;Ledger Balance:
                     <CurrencyFormat value={balance} displayType={'text'} thousandSeparator={true} /> {currency}&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
                  </h3>
                    </>)
                  }
                 
                </div>
                
              </div>
              {
            isIssuerBalanceSkrill && masterClientId!=278 &&(<>
          
           <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-30">Skrill Main Wallet Balance: <CurrencyFormat value={apiBalanceIssuerSkrill} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
            </>)
          }
              {isKapedClient &&(
                <>
                  <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-50">Issuer Balance: <CurrencyFormat value={apiBalanceKaped} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
          
                </>
           
           
          )}
          
          {
            isIssuerBalanceM &&(<>
             <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-30">Issuer Balance Load Wallet: <CurrencyFormat value={apiBalanceKaped} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
           <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-30">Issuer Balance Debit Wallet: <CurrencyFormat value={apiBalanceIssuerM} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
            </>)
          }
          {
            isIssuerBalanceX &&(<>
          
           <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-30">Issuer Balance X: <CurrencyFormat value={apiBalanceIssuerM} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
            </>)
          }
          {
            isIssuerBalanceWex &&(<>
          
           <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-30">Issuer Balance WEX: <CurrencyFormat value={apiBalanceIssuerWex} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
            </>)
          }
          {
            isIssuerBalanceCap &&(<>
          
           <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >
{
  IssuerCategory==="IssuerCap-NKT" ?(<>
   <h3 className="text-center mt-30">Issuer Balance CAP-NKT: <CurrencyFormat value={apiBalanceIssuerCap} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
  </>):(<>  <h3 className="text-center mt-30">Issuer Balance CAP-SG: <CurrencyFormat value={apiBalanceIssuerCap} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3></>)
}
             
                
             </div>

           </div>
            </>)
          }
          {
            isIssuerBalanceESL &&(<>
          
           <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-30">Issuer Balance ESL: <CurrencyFormat value={apiBalanceIssuerESL} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
            </>)
          }
          {
            isIssuerBalanceER &&(<>
          
           <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-30">Issuer Balance ESL: <CurrencyFormat value={apiBalanceIssuerER} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
            </>)
          }
           {
            isIssuerBalanceOB &&(<>
          
           <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-30"> {
               IssuerCategory==="Issuer11" ? (<>Issuer Balance 11: </>):
               IssuerCategory==="Issuer12"?(<>Issuer Balance WGS : </>):
                IssuerCategory==="OB-TIX"?(<>Issuer Balance OB-TIX : </>):
                 IssuerCategory==="OB-FIT"?(<>Issuer Balance OB-FIT : </>):
                  IssuerCategory==="OB-OF"?(<>Issuer Balance OB-OF : </>):
               (<>Issuer Balance OB: </>)}
                 <CurrencyFormat value={apiBalanceIssuerOB} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
            </>)
          }
           {
            isIssuerBalanceTGVN &&(<>
          
           <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-30">Issuer Balance TGVN: <CurrencyFormat value={apiBalanceIssuerTGVN} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
            </>)
          }
          {
            isFrozenBalances &&(<>
             <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >

               <h3 className="text-center mt-20">Frozen Load : <CurrencyFormat value={Frozenloadbalance} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
                <h3 className="text-center mt-20">Frozen Debit : <CurrencyFormat value={Frozendebitbalance} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>
             </div>

           </div>
            
            </>)
          }
          {isIssuerIClient &&(
             <div className="col-sm-3 col-xl-3">
             <div
               className="col-stats col-stats-card mb-sm-40 mb-4 col-ledger"
               style={{ backgroundImage: `url(${""})`, height: `11rem` }}
             >
              {
                apiBalanceIssuerI ?( <h3 className="text-center mt-50">Issuer Balance: <CurrencyFormat value={apiBalanceIssuerI} displayType={'text'} thousandSeparator={true} /> {"USD"}
               </h3>):( <h3 className="text-center mt-50"> Loading.....
                </h3>)
              }
              
             </div>
           </div>
          )}
          
            {haspermissions.LedgerTransfer && (
          <div
            className="col-md-2 col-sm-6 col-xl-2"
            onClick={() => setModalShowTransferClient(true)}
          >
            <div className="col-stats col-stats-action mb-40">
              <div>
                <span className="icon-load-card">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                  <span className="path10"></span>
                  <span className="path11"></span>
                  <span className="path12"></span>
                  <span className="path13"></span>
                  <span className="path14"></span>
                </span>
                <br />
                <Link to="#" className="mt-3">
                  Ledger Transfer
                  <span className="icon-bo-arrow"></span>
                </Link>
              </div>
            </div>
          </div>
        )}
            </Fragment>
            )}
        
             <>
            {
              haspermissions.ViewLedgerHistory && (
               
                <div className={isledgerhistory} Style={"width=82px"} >
                   {
                  isExcelDownload ?(
                  <Fragment>
                    <div>
                    <ExportToExcel
                  Dataset={dataset}
                  calledfrom="ledgerclient"
                  Name={"LedgerClient"}
                />
                <button id="searchBtnExportToExcel"className="btn btn-large mt-3" onClick={resetModal}>Reset</button>
                    </div>
                    </Fragment>
                  ):(
                  <button id="searchBtnExportToExcel"className="btn btn-large mr-19" onClick={showExcelModel}> Export</button>)
                }

                  
                </div>
              )}
           </>
          </div>
  
        </div>
            <>
       
         {haspermissions.ViewLedgerHistory && (
            <Fragment>
              {masterClientId==303 && (
                <div className="bo-tabs-mbl">
                  <ul className="nav nav-tabs nav-tabs-profile" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className={wexTabActive ? "nav-link d-flex align-items-center" : "nav-link active d-flex align-items-center"}
                        type="button"
                        role="tab"
                        aria-selected={!wexTabActive}
                        onClick={() => switchTransactionsTab(false)}
                      >
                        <span className="icon-transaction"></span>Transactions
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={wexTabActive ? "nav-link active d-flex align-items-center" : "nav-link d-flex align-items-center"}
                        type="button"
                        role="tab"
                        aria-selected={wexTabActive}
                        onClick={() => switchTransactionsTab(true)}
                      >
                        <span className="icon-transaction"></span>WEX Transactions
                      </button>
                    </li>
                  </ul>
                </div>
              )}
              {/* no client found  */}
              <div className="d-flex align-content-center justify-content-center no-clients-msg d-none">
                <div className="text-center">
                  <span className="icon-clients-empty">
                    <span className="path1"></span><span className="path2"></span>
                    <span className="path3"></span><span className="path4"></span>
                    <span className="path5"></span><span className="path6"></span>
                  </span>
                  {/* <img src="../../assets/images/icons/clients-empty.svg" /> */}
                  <h3>Empty Transaction Listing</h3>
                  <h6>There is no Transactio(s) available for now.</h6>
                </div>
              </div>
              <Fragment>
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="row row-search">

                    <div className="col-xl-12 col-12">
                      <div className="form-group">
                        <div className="form-controls">
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props?.placeholdervalue}
                            onClick={handleInputSearchClick}
                            disabled={SearchInputDisabled}
                          />
                          <span className="icon-search _ico"></span>
                          {/* search box  */}
                          <div
                            className="bo-cardsearch"
                            style={{ display: modalShow ? "" : "none" }}
                          >
                            <div className="row">
                              <div className="col-sm-6">
                                <div className="col-md-4">
                                  <img
                                    className="cross-icon cross-modal"
                                    src={crossImgs}
                                    aria-label="Close"
                                    onClick={HideSearchPopupDiv}
                                    alt=""
                                  />
                                </div>{
                                  isIssuerBalanceSkrill ?( <div className=" col-md-12 form-group form-search mr-20">
                                  
                                  <label>Amount</label>
                                  <div className="form-controls mr-20">
                                    <input
                                      type="text"
                                      value={Amount}
                                      onChange={AmountChangeHandler}
                                      className="form-control"
                                      maxLength={40}
                                    />
                                  </div>
                                </div>) :(<div className=" col-md-12 form-group form-search mr-20">
                                  
                                  <label>Name</label>
                                  <div className="form-controls mr-20">
                                    <input
                                      type="text"
                                      value={name}
                                      onChange={nameChangeHandler}
                                      className="form-control"
                                      maxLength={40}
                                    />
                                  </div>
                                </div>)
                                }
                               
                              </div>
                             
                              <div className="col-md-6">
                                
                                <div className="form-group form-search mr-20">
                                  <label>Date From</label>
                                  <div className="form-controls">
                                    <ReactDatePickerHelper
                                      datevalue={dateFrom}
                                      onchangedate={dateFromHandler}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group form-search mr-20">
                                  <label>Date To</label>
                                  <div className="form-controls">
                                    <ReactDatePickerHelper
                                      datevalue={dateTo}
                                      onchangedate={dateToHandler}
                                    />
                                  </div>
                                </div>
                              </div>

                              
                               {
                                isIssuerBalanceSkrill ?(<div className="col-md-6">
                              <div className="form-group form-search mr-20">
                                <label>Txn Id</label>
                                <div className="form-controls">
                              <input type="text"
                              value={tokenId}
                              onChange={tokenChangeHandler}
                              className="form-control"/>
                                </div>
                              </div>
                             
                            </div>
                            ):(<div className="col-md-6">
                              <div className="form-group form-search mr-20">
                                <label>Token Id</label>
                                <div className="form-controls">
                              <input type="number" pattern="\d*" maxlength="10"
                              value={tokenId}
                              onChange={tokenChangeHandler}
                              className="form-control"/>
                                </div>
                              </div>
                             
                            </div>
                            )
                              }
                            {
                              isIssuerBalanceSkrill ?( <div className="col-md-6">
                              <div className="form-group form-search mr-20">
                                <label>Status</label>
                                <div className="form-controls">
                              <input type="text"
                              value={Status}
                              onChange={StatusChangeHandler}
                              className="form-control"/>
                                </div>
                              </div>
                            </div>):( <div className="col-md-6">
                              <div className="form-group form-search mr-20">
                                <label>Transaction Type</label>
                                <div className="form-controls">
                              <input type="text"
                              value={TransactionType}
                              onChange={transactionTypeChangeHandler}
                              className="form-control"/>
                                </div>
                              </div>
                            </div>)
                            }
                           
                            <div className="col-md-6 form-checkbox mb-16 mt-16">
                              <input
                               type="checkbox"
                               name="olderdatachk"
                               id="olderdatachk"
                               onClick={(e) => handleSingleCheck(e)}
                              />
                              <label class="checkbox-label" for="olderdatachk">
                                More Than 3 Months
                              </label>
                            </div>

                              <div className="col-md-12">
                                <div className="form-group submit-field form-search">
                                  <button
                                    id="searchBtnClients"
                                    className="btn btn-large mr-19"
                                    onClick={SearchClickHandler}
                                  >
                                    Search
                                  </button>
                                  <button
                                    className="btn btn-outline"
                                    onClick={ClearSearchData}
                                  >
                                    Clear Search
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <span className="help-block d-none"></span>
                      </div>
                    </div>
                  </div>
                </form>
              </Fragment>
            </Fragment>
          )}
       
        {
          haspermissions.ViewLedgerHistory && (
            <Fragment>
              {searchGridSuccess && (
                <div className="table-wrap" ref={searchTbl}>

                  <table
                    className="table table-borderless bo-table table-cards"
                    onScroll={tblScrollHandler}
                    onWheel={tblScrollHandler}
                  >
                    <thead>
                      <tr>{renderTableHeader()}</tr>
                    </thead>
                    <tbody>{renderTableData()}</tbody>
                  </table>
                </div>
              )}
            </Fragment>
          )
        }
       
        {
          haspermissions.ViewLedgerHistory && (
            <Fragment>
              {loadingData ? (
                <div className="loading-more">
                  <div className="loader">
                    <div></div>
                  </div>
                  <p>loading data</p>
                </div>
              ) : totalCount === 0 ? (
                <div className="d-flex align-content-center justify-content-center  no-clients-msg">
                  <div className="text-center">
                    <span className="icon-clients-empty">
                      <span className="path1"></span><span className="path2"></span>
                      <span className="path3"></span><span className="path4"></span>
                      <span className="path5"></span><span className="path6"></span>
                    </span>
                    {/* <img src={emptyclient} /> */}
                    <h3>Empty Transaction Listing</h3>
                    <h6>There is no Transation(s) available for now.</h6>
                  </div>
                </div>
              ) : (
                ""
              )}
            </Fragment>
          )
        }</>

        
      </div>
      
      
      
      <ModelPopup
          show={showExcelDownloadModal}
          onHide={() => setshowExcelDownloadModal(false)}
          modelheading={""}
          showheader={"false"}
          className="smallPopup issueCardSmall"
          dialogClassName="modal-dialog modal-dialog-centered mwidth-52"
          backdrop="static"
          keyboard={false}
          modelbody={[
            <Fragment>
              <div className="row">
                <div className="col-md-12">
                  <h2>Export To Excel</h2>
                  <div className="mt-16">
                    <div>
                      <form onSubmit={(e) => e.preventDefault()}>
                        <div className="row">
                         
                          <div className="col-md-6">
                                <div className="form-group form-search mr-20">
                                  <label>Date From</label>
                                  <div className="form-controls">
                                    <ReactDatePickerHelper
                                      datevalue={dateFrom}
                                      onchangedate={dateFromHandler}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group form-search mr-20">
                                  <label>Date To</label>
                                  <div className="form-controls">
                                    <ReactDatePickerHelper
                                      datevalue={dateTo}
                                      onchangedate={dateToHandler}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6 form-checkbox mb-16 mt-16">
                              <input
                               type="checkbox"
                               name="olderdatachks"
                               id="olderdatachks"
                               onClick={(e) => handleSingleCheck(e)}
                              />
                              <label class="checkbox-label" for="olderdatachks">
                                More Than 3 Months
                              </label>
                            </div>
                              
                          <div className="col-md-12">
                            <div className="form-group submit-field d-flex justify-content-between mt-20 mb-0">
                            
                              <button
                                className="btn btn-large"
                                onClick={downloadExportToExcel}
                              >
                                Done
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>,
          ]}
        />
         <ModelPopup
          key={1}
          show={modalShowTransactions}
          onHide={() => {setModalShowTransactions(false); refereshTransac();}}
          modelheading={""}
          modelbody={renderTransactionDetails()}
          showheader={"false"}
          dialogClassName="modal-dialog modal-dialog-centered mwidth-52"
          className="smallPopup issueCardSmall"
          backdrop="static"
          keyboard={false}
        />
        <TransferClient
          show={modalShowTransferClient}
          onHide={() => setModalShowTransferClient(false)}
        />
      </>
      )}
    </div>
  );
};

export default SearchGridDebitTransaction;
